export default {
  name: "Roles",

  data() {
    return {
      search: "",

      tree: [
        {
          id: 1,
          name: "Administration",
          open: false,
          checked: false,
          children: [
            { id: 11, name: "Device Controllers", checked: false },
            { id: 12, name: "Field Privileges", checked: false },
            { id: 13, name: "ICF", checked: false },
            { id: 14, name: "Organization Settings", checked: false },
            { id: 15, name: "Protocol Extraction", checked: false },
            { id: 16, name: "Role Privileges", checked: false },
            { id: 17, name: "Roles", checked: false },
            { id: 18, name: "Users", checked: false }
          ]
        },

        {
          id: 2,
          name: "Analytical Dashboards",
          open: false,
          checked: false,
          children: [
            { id: 21, name: "Adverse Events Summary", checked: false },
            { id: 22, name: "Clinical Trial Analytics", checked: false },
            { id: 23, name: "Demographics Summary", checked: false },
            { id: 24, name: "Death Summary Report", checked: false }
          ]
        },

        {
          id: 3,
          name: "Audit Trail",
          open: false,
          checked: false,
          children: [
            { id: 31, name: "Sites", checked: false },
            { id: 32, name: "Study List", checked: false },
            { id: 33, name: "Subjects", checked: false },
            { id: 34, name: "Users", checked: false }
          ]
        },

        {
          id: 4,
          name: "CRA Visit Management",
          open: false,
          checked: false,
          children: [
            { id: 41, name: "CRA Dashboard", checked: false },
            { id: 42, name: "Issue List", checked: false },
            { id: 43, name: "KPI List", checked: false },
            { id: 44, name: "Risk Sites", checked: false }
          ]
        },

        {
          id: 5,
          name: "Dashboard",
          open: false,
          checked: false,
          children: [
            { id: 51, name: "Main Dashboard", checked:false},
            { id: 52, name: "Nurse Dashboard", checked: false },
            { id: 53, name: "Study Summary", checked: false },
            { id: 54, name: "Subject Dashboard", checked: false }
          ]
        },

        {
          id: 6,
          name: "Data Entry",
          open: false,
          checked: false,
          children: [
            { id: 61, name: "Fill Form", checked: false },
            { id: 62, name: "View", checked: false }
          ]
        }
      ]
    };
  },

  computed: {
    filteredTree() {
      if (!this.search) return this.tree;

      return this.tree
        .map(folder => ({
          ...folder,
          children: folder.children.filter(child =>
            child.name.toLowerCase().includes(this.search.toLowerCase())
          )
        }))
        .filter(
          folder =>
            folder.children.length ||
            folder.name.toLowerCase().includes(this.search.toLowerCase())
        );
    }
  },

  methods: {
    toggle(folder) {
      folder.open = !folder.open;
    },

    expandAll() {
      this.tree.forEach(folder => {
        folder.open = true;
      });
    },

    collapseAll() {
      this.tree.forEach(folder => {
        folder.open = false;
      });
    }
  }
};